<!--
The wrapper's flexbox styles are translated from the configured layout tokens
(direction defaults to column). The dynamic children are created into the
appDynamicContent anchor.

Optional aria-label provides semantic structure for screen reader users to navigate between
distinct sections within a screen (e.g., "Quiz Instructions", "Answer Options").

Nothing renders until a config with a non-empty componentArray arrives.
-->
@if (templateData(); as templateData) {
  <div class="container-flex" [attr.aria-label]="templateData.ariaLabel" [style]="templateData.style">
    <ng-template appDynamicContent />
  </div>
}
